import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const ErrorMessage = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: ${DEFAULT_COLORS.ink.dark};
  margin: 0;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
